"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _line = require("@nivo/line");

var _linechart_helpers = _interopRequireDefault(require("../linechart_helpers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// https://nivo.rocks/line/
// utils

/* ========== ~~~~~~~~~~ EXPORT CHART : LINE : DETAIL ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  //ensuring that we have data, then binding dateLength to the length of dates,
  // Nivo will dynamically split anything under 9 x ticks and spread them between 9 ticks, causing double instances of x ticks
  var dateLength = !!props.data[0] ? props.data[0].data.length : 0;

  var xScale = function xScale(xType) {
    switch (xType) {
      case 'date':
        return {
          type: 'time',
          format: '%Y-%m-%d',
          precision: 'day',
          useUTC: false
        };

      default:
        return undefined;
    }
  };

  var axisBottomFormat = function axisBottomFormat(xType) {
    switch (xType) {
      case 'date':
        return '%b %d';

      default:
        return undefined;
    }
  };

  return _react.default.createElement(_line.ResponsiveLine, {
    data: props.data,
    margin: {
      "top": 5,
      "right": 35,
      "bottom": 45,
      "left": 80
    },
    xScale: xScale(props.xType),
    yScale: {
      "type": "linear",
      "stacked": false,
      "min": "auto",
      "max": "auto"
    },
    axisBottom: {
      "orient": "bottom",
      "tickSize": 0,
      "tickPadding": 20,
      "tickRotation": 0,
      "legend": "",
      "legendOffset": 36,
      "legendPosition": "middle",
      "format": axisBottomFormat(props.xType),
      "tickValues": dateLength <= 9 ? dateLength : undefined
    },
    axisLeft: {
      "orient": "left",
      "tickSize": 0,
      "tickPadding": 20,
      "tickRotation": 0,
      "legend": "",
      "legendOffset": -40,
      "legendPosition": "middle",
      "format": function format(value) {
        return (0, _linechart_helpers.default)(value, props.yType);
      }
    },
    yFormat: function yFormat(value) {
      return (0, _linechart_helpers.default)(value, props.yType);
    },
    enableGridX: false,
    enableGridY: true,
    lineWidth: 2,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    axisTop: null,
    axisRight: null,
    colors: {
      scheme: 'set1'
    },
    enablePoints: false,
    enableArea: false,
    crosshairType: "x",
    useMesh: true,
    legends: [],
    enableSlices: 'x'
  });
};

exports.default = _default;